import { OrganizationIntegrationAccountItem } from "@common/schemas/organization-connection-groups.schema";
import { emptyToNull } from "@common/helpers/string";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";
import { UserAvatar } from "@components/avatar/UserAvatar";

/**
 * Avatar-only "Connected by" cell — the name lives in the tooltip, so the
 * column stays narrow. Falls back to a dash for connections with no creator
 * (native connections can have a null `createdByUser`).
 */
export const ConnectedByCell = ({
    item,
}: {
    item: OrganizationIntegrationAccountItem;
}) => {
    const { connectedBy } = item.connection;
    const label =
        emptyToNull(connectedBy?.name) ?? emptyToNull(connectedBy?.email);

    if (!connectedBy || !label) {
        return <>-</>;
    }

    return (
        <AvatarTooltip content={label}>
            <UserAvatar
                size="xs"
                user={{
                    name: label,
                    email: connectedBy.email,
                    avatar: connectedBy.avatar,
                    iconColor: connectedBy.iconColor,
                }}
            />
        </AvatarTooltip>
    );
};
